import { useSelector } from 'react-redux';
import { LayoutType, WaveType } from 'signup-components/types';
import { useSignupEmbedder } from 'signup-embedder/hooks/useSignupEmbedder';
import { ErrorKey } from '../app-active-error/ErrorKey';
import { getFlowConfig } from '../flow-initial/getFlowConfig';
import { useMessage } from '../messaging/useMessage';
import { getActiveError } from '../store/error/selectors';
import { getPostAccountCreationSteps } from '../store/flow/selectors';
import { Step } from '../views/Step';
import { getStepConfig } from '../views/getStepConfig';
import { useCurrentStep } from './useCurrentStep';
export const getWaveType = ({
  currentStep,
  activeError,
  postAccountCreationSteps
}) => {
  let waveType;
  const isPostAccountCreationStep = postAccountCreationSteps.includes(currentStep);
  const shouldShowErrorWave = activeError || Object.values(ErrorKey).some(key => key.toString() === currentStep);

  if (currentStep === Step.ExistingUser || currentStep === Step.ExistingAccounts) {
    waveType = WaveType.Yellow;
  }

  if (shouldShowErrorWave) {
    waveType = WaveType.Error;
  }

  if (isPostAccountCreationStep && getFlowConfig().shouldUseWaveOnPostAccountCreation) {
    return WaveType.LowOrange;
  }

  return waveType;
};
export const useLayoutTemplate = () => {
  const postAccountCreationSteps = useSelector(getPostAccountCreationSteps);
  const {
    currentStep
  } = useCurrentStep();
  const activeError = useSelector(getActiveError);
  const step = activeError || currentStep;
  const stepConfig = getStepConfig(step);
  const {
    isActive: isInstanceOfSignupEmbedder
  } = useSignupEmbedder();
  const showMessagingAboveContent = stepConfig && stepConfig.showMessagingAboveContent;
  const {
    shouldDisplayMessaging
  } = useMessage();
  const layoutType = shouldDisplayMessaging && !showMessagingAboveContent ? LayoutType.TwoColumn : getFlowConfig().getLayoutType();
  const waveType = getWaveType({
    currentStep,
    activeError,
    postAccountCreationSteps
  });
  const shouldStepUseLayoutTemplate = stepConfig ? stepConfig.shouldStepUseLayoutTemplate : false;
  const isPostAccountCreationStep = postAccountCreationSteps.includes(currentStep);

  if (isPostAccountCreationStep && !isInstanceOfSignupEmbedder) {
    return {
      shouldUseLayoutTemplate: true,
      layoutType,
      waveType
    };
  }

  if (shouldStepUseLayoutTemplate) {
    return {
      shouldUseLayoutTemplate: true,
      layoutType,
      waveType
    };
  }

  return {
    shouldUseLayoutTemplate: false,
    layoutType,
    waveType
  };
};